"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authreducerFunction = exports.authActions = exports.authState = exports.initialState = void 0;
var immer_reducer_1 = require("immer-reducer");
var userLight_1 = __importDefault(require("../models/userLight"));
exports.initialState = {
    data: {
        //email is used for first connexion only is null oherwise
        email: null,
        login: null,
        isPasswordExpired: false,
        refreshToken: null,
        accessToken: null,
        expireDate: null,
        expiresInSecondes: null,
        refreshExpiresInSecondes: null,
        isForgetPasswordRedirectionUrlExpired: false,
        forgetPasswordEmail: null,
        tenantId: null
    },
    updateEmailNewsLetter: {
        loading: false,
        errorMsg: null,
        firstStepResult: 'none',
        isUpdateEmailRedirectionUrlExpired: false
    },
    errorMessage: null,
    errorCode: null,
    recaptchaV3Failed: false,
    IdentifiedUserErrorMessage: null,
    loading: false,
    loaded: false,
    userAuthentified: null,
    errorNewCreatedUser: null,
    checkUserInfosSuccess: false,
    clientAccounts: null,
    userFirstName: null,
    createAccountData: {
        setPasswordSuccess: false,
        createAccountSuccess: false,
        loading: false,
        userReference: null,
        userEmail: null,
        acceptSaurContact: null,
        emailSentToUser: false,
        userName: null,
        userFirstName: null,
        userLastName: null,
        socialReason: null,
        errorMessage: null,
        createUserCaptchaToken: null,
        resendSubscriptionMailLoading: false,
        resendSubscriptionMailSuccess: false,
        resendSubscriptionMailErrorMessage: null
    },
    finalizeCreateAccountLoading: false,
    finalizeCreateAccountErrorMessage: null,
    updateEmailData: {
        firstStepResult: 'none',
        isUpdateEmailRedirectionUrlExpired: false
    },
    updateEmailWithIbanOrBilling: {
        loading: false,
        errorMsg: null
    },
    unsubscribe: {
        errorMessage: null,
        success: false
    },
    logoutV2: {
        loading: false,
        success: false,
        errorMessage: null,
        technicalErrorMessage: undefined
    }
};
var authState = /** @class */ (function (_super) {
    __extends(authState, _super);
    function authState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    authState.prototype.setAuthentifiedUser = function (user) {
        this.draftState.userAuthentified = user;
    };
    authState.prototype.setAuthentifiedUserInformations = function (payload) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var defaultContract = __assign(__assign({}, (_a = this.draftState.userAuthentified) === null || _a === void 0 ? void 0 : _a.defaultContract), { contractTerminationDate: payload.contractTerminationDate, contractStatusCode: payload.contractStatusCode, isContractTerminated: payload.isContractTerminated });
        this.draftState.userAuthentified = {
            clientId: payload.clientId,
            firstName: (_c = (_b = this.draftState.userAuthentified) === null || _b === void 0 ? void 0 : _b.firstName) !== null && _c !== void 0 ? _c : '',
            lastName: (_e = (_d = this.draftState.userAuthentified) === null || _d === void 0 ? void 0 : _d.lastName) !== null && _e !== void 0 ? _e : '',
            defaultContractId: (_g = (_f = this.draftState.userAuthentified) === null || _f === void 0 ? void 0 : _f.defaultContractId) !== null && _g !== void 0 ? _g : '',
            defaultDeliveryPointId: (_j = (_h = this.draftState.userAuthentified) === null || _h === void 0 ? void 0 : _h.defaultDeliveryPointId) !== null && _j !== void 0 ? _j : '',
            isFamilyMode: payload.isFamilyMode,
            defaultFamilyId: (_l = (_k = this.draftState.userAuthentified) === null || _k === void 0 ? void 0 : _k.defaultFamilyId) !== null && _l !== void 0 ? _l : '',
            defaultContract: defaultContract,
            defaultSectionId: payload.sectionSubscriptionId,
            defaultSectionIds: payload.sectionSubscriptionIds,
            clientReference: payload.clientReference,
            defaultCustomerAccountId: payload.customerAccountId,
            isEligibleCoachConso: payload.isEligibleCoachConso,
            isEligibleNewFeaturesMessage: payload.isEligibleNewFeaturesMessage,
            pairingTechnologyCode: payload.pairingTechnologyCode,
            isMultiTargetAlertsEnabled: payload.isMultiTargetAlertsEnabled
        };
    };
    authState.prototype.setAuthentifiedUserFamily = function (payload) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        var defaultContract = __assign({}, (_a = this.draftState.userAuthentified) === null || _a === void 0 ? void 0 : _a.defaultContract);
        this.draftState.userAuthentified = __assign(__assign({}, this.draftState.userAuthentified), { clientId: (_c = (_b = this.draftState.userAuthentified) === null || _b === void 0 ? void 0 : _b.clientId) !== null && _c !== void 0 ? _c : '', firstName: (_e = (_d = this.draftState.userAuthentified) === null || _d === void 0 ? void 0 : _d.firstName) !== null && _e !== void 0 ? _e : '', lastName: (_g = (_f = this.draftState.userAuthentified) === null || _f === void 0 ? void 0 : _f.lastName) !== null && _g !== void 0 ? _g : '', defaultContractId: (_j = (_h = this.draftState.userAuthentified) === null || _h === void 0 ? void 0 : _h.defaultContractId) !== null && _j !== void 0 ? _j : '', defaultDeliveryPointId: (_l = (_k = this.draftState.userAuthentified) === null || _k === void 0 ? void 0 : _k.defaultDeliveryPointId) !== null && _l !== void 0 ? _l : '', defaultContract: defaultContract, defaultSectionId: (_o = (_m = this.draftState.userAuthentified) === null || _m === void 0 ? void 0 : _m.defaultSectionId) !== null && _o !== void 0 ? _o : '', clientReference: (_q = (_p = this.draftState.userAuthentified) === null || _p === void 0 ? void 0 : _p.clientReference) !== null && _q !== void 0 ? _q : '', defaultCustomerAccountId: (_s = (_r = this.draftState.userAuthentified) === null || _r === void 0 ? void 0 : _r.defaultCustomerAccountId) !== null && _s !== void 0 ? _s : '', pairingTechnologyCode: (_u = (_t = this.draftState.userAuthentified) === null || _t === void 0 ? void 0 : _t.pairingTechnologyCode) !== null && _u !== void 0 ? _u : '', defaultSectionIds: payload.sectionSubscriptionIds, isFamilyMode: payload.isFamilyMode, defaultFamilyId: payload.familyId, isEligibleCoachConso: (_v = this.draftState.userAuthentified) === null || _v === void 0 ? void 0 : _v.isEligibleCoachConso, isEligibleNewFeaturesMessage: (_w = this.draftState.userAuthentified) === null || _w === void 0 ? void 0 : _w.isEligibleNewFeaturesMessage, isMultiTargetAlertsEnabled: (_x = this.draftState.userAuthentified) === null || _x === void 0 ? void 0 : _x.isMultiTargetAlertsEnabled });
    };
    /**
     * Action d'authentificaton. Utilisée uniquement par le mobile
     * @param payload Les identifiants pour se connecter
     */
    authState.prototype.login = function (payload) {
        // no change
    };
    /**
     * Action levée en cas de success d'authentification
     * @param payload Les credentials passés lors de la tentative de connexion
     */
    authState.prototype.loginSuccess = function (payload) {
        // no change
    };
    /**
     * Action levée en cas d'echec d'authentification
     */
    authState.prototype.loginFailure = function () {
        // no change
    };
    authState.prototype.signin = function (payload) {
        this.getToken(payload);
        this.draftState.errorCode = null;
        this.draftState.data.email = payload.email;
    };
    authState.prototype.signinFailure = function (errorMessage, errorCode, recaptchaV3Failed, payload) {
        var tmpEmail = this.draftState.data.email;
        if (errorCode === 412) {
            this.signinSuccess(payload);
        }
        if (errorCode === 412 || errorCode === 404) {
            this.draftState.data.email = tmpEmail;
        }
        else {
            this.draftState.data.email = null;
        }
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMessage;
        this.draftState.errorCode = errorCode;
        this.draftState.recaptchaV3Failed = recaptchaV3Failed || false;
    };
    authState.prototype.signinSuccess = function (payload) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.data.accessToken = payload.token.access_token;
        this.draftState.data.refreshToken = payload.token.refresh_token;
        this.draftState.userAuthentified = new userLight_1.default(payload);
        this.draftState.errorMessage = null;
        this.draftState.data.email = null;
        this.draftState.data.isPasswordExpired = false;
        var current_date = new Date();
        // 15 min into current date
        var minExpireDate = Number(payload.token.expires_in) / 60;
        var expire_date = current_date.setMinutes(current_date.getMinutes() + minExpireDate);
        this.draftState.data.expireDate = new Date(expire_date);
        this.draftState.data.expiresInSecondes = Number(payload.token.expires_in);
        this.draftState.data.refreshExpiresInSecondes = Number(payload.token.refresh_expires_in);
        this.draftState.errorCode = null;
    };
    authState.prototype.getToken = function (payload) {
        this.draftState.loading = true;
        this.draftState.errorMessage = null;
        this.draftState.errorCode = null;
        this.draftState.data.email = null;
    };
    authState.prototype.getTokenFailure = function (errorMessage, recaptchaV3Failed) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMessage;
        this.draftState.errorCode = null;
        this.draftState.data.email = null;
        this.draftState.recaptchaV3Failed = recaptchaV3Failed || false;
    };
    authState.prototype.getTokenSuccess = function (payload) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.data.accessToken = payload.token.access_token;
        this.draftState.data.refreshToken = payload.token.refresh_token;
        this.draftState.userAuthentified = new userLight_1.default(payload);
        this.draftState.errorMessage = null;
        this.draftState.data.email = null;
        this.draftState.data.isPasswordExpired = false;
        var current_date = new Date();
        // 15 min into current date
        var minExpireDate = Number(payload.token.expires_in) / 60;
        var expire_date = current_date.setMinutes(current_date.getMinutes() + minExpireDate);
        this.draftState.data.expireDate = new Date(expire_date);
        this.draftState.data.expiresInSecondes = Number(payload.token.expires_in);
        this.draftState.data.refreshExpiresInSecondes = Number(payload.token.refresh_expires_in);
    };
    authState.prototype.setToken = function (accessToken) {
        this.draftState.data.accessToken = accessToken;
    };
    authState.prototype.setExpireDateToken = function (date) {
        this.draftState.data.expireDate = date;
    };
    authState.prototype.setRefreshToken = function (refreshToken) {
        this.draftState.data.refreshToken = refreshToken;
    };
    authState.prototype.fetchIdentifiedUser = function (payload) {
        this.draftState.loading = true;
        this.draftState.data.email = payload.email;
    };
    authState.prototype.fetchIdentifiedUserSuccess = function (identifiedUser) {
        this.draftState.loading = false;
        this.draftState.data.isPasswordExpired =
            identifiedUser.resetPassword && identifiedUser.active == 1;
        this.draftState.data.tenantId = identifiedUser.tenantId;
        this.draftState.IdentifiedUserErrorMessage = null;
    };
    authState.prototype.fetchIdentifiedUserError = function (errorMessage) {
        this.draftState.loading = false;
        this.draftState.IdentifiedUserErrorMessage = errorMessage;
    };
    authState.prototype.initializeUser = function (payload) {
        this.draftState.loading = true;
    };
    authState.prototype.initializeUserSuccess = function () {
        this.draftState.loading = false;
        this.draftState.errorMessage = null;
        this.draftState.data.email = null;
        this.draftState.data.isPasswordExpired = false;
    };
    authState.prototype.initializeUserError = function (errorMessage) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMessage;
    };
    authState.prototype.sendEmail = function (email) {
        this.draftState.loading = true;
        this.draftState.errorMessage = null;
        this.draftState.data.forgetPasswordEmail = email;
    };
    authState.prototype.sendEmailSuccess = function () {
        this.draftState.loading = false;
    };
    authState.prototype.sendEmailError = function (errorMsg) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMsg;
    };
    authState.prototype.resetPassword = function (_a) {
        var tokenEmail = _a.tokenEmail, newPassword = _a.newPassword;
        this.draftState.loading = true;
    };
    authState.prototype.resetPasswordError = function (errorMsg) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMsg;
    };
    authState.prototype.resetPasswordSuccess = function () {
        this.draftState.loading = false;
        this.draftState.errorMessage = null;
    };
    authState.prototype.logout = function () {
        this.draftState.loading = true;
    };
    authState.prototype.logoutSuccess = function (tokenExpired) {
        this.draftState = exports.initialState;
    };
    authState.prototype.logoutFailure = function (errorMsg, technicalErrorMessage) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMsg;
        this.draftState.technicalErrorMessage = technicalErrorMessage;
    };
    authState.prototype.logoutV2 = function (clientId) {
        this.draftState.loading = true;
    };
    authState.prototype.logoutSuccessV2 = function (tokenExpired) {
        this.draftState = exports.initialState;
    };
    authState.prototype.logoutFailureV2 = function (errorMsg, technicalErrorMessage) {
        this.logoutFailure(errorMsg, technicalErrorMessage);
    };
    authState.prototype.checkTokenValidity = function (token) {
        this.draftState.loading = true;
    };
    authState.prototype.checkTokenValidityError = function (errorMsg, isExpired) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMsg;
        this.draftState.data.isForgetPasswordRedirectionUrlExpired = isExpired;
    };
    authState.prototype.checkTokenValiditySuccess = function () {
        this.draftState.loading = false;
        this.draftState.errorMessage = null;
        this.draftState.data.isForgetPasswordRedirectionUrlExpired = false;
    };
    authState.prototype.getAuthentifiedUser = function () {
        this.draftState.loading = true;
        this.draftState.errorMessage = null;
        this.draftState.loaded = false;
    };
    authState.prototype.getAuthentifiedUserSuccess = function (user) {
        this.draftState.loading = false;
        this.draftState.userAuthentified = user;
        this.draftState.loaded = true;
    };
    authState.prototype.getAuthentifiedUserFailure = function (errorMessage) {
        this.draftState.errorMessage = errorMessage;
        this.draftState.loading = false;
        this.draftState.loaded = false;
    };
    authState.prototype.checkAndGetContractUser = function (payload) {
        this.draftState.loading = true;
        this.draftState.errorMessage = null;
        this.draftState.checkUserInfosSuccess = false;
        this.draftState.userFirstName = null;
        this.draftState.clientAccounts = null;
    };
    authState.prototype.checkAndGetContractUserSuccess = function (clients) {
        this.draftState.loading = false;
        this.draftState.checkUserInfosSuccess = true;
        this.draftState.clientAccounts = clients;
        this.draftState.errorMessage = null;
    };
    authState.prototype.checkAndGetContractUserFailure = function (errorMessage) {
        this.draftState.errorNewCreatedUser = errorMessage;
        this.draftState.loading = false;
        this.draftState.checkUserInfosSuccess = false;
        this.draftState.clientAccounts = null;
        this.draftState.userFirstName = null;
    };
    authState.prototype.checkNewIdentifiedUser = function (payload) {
        this.draftState.createAccountData.loading = true;
        this.draftState.createAccountData.errorMessage = null;
        this.draftState.createAccountData.createAccountSuccess = false;
        this.draftState.createAccountData.userName = payload.userName;
        this.draftState.createAccountData.userReference =
            payload.userReferenceId;
    };
    authState.prototype.checkNewIdentifiedUserSuccess = function (restrictedClientData) {
        this.draftState.createAccountData.loading = false;
        this.draftState.createAccountData.createAccountSuccess = true;
        this.draftState.createAccountData.errorMessage = null;
        this.draftState.createAccountData.userFirstName =
            restrictedClientData === null || restrictedClientData === void 0 ? void 0 : restrictedClientData.firstName;
        this.draftState.createAccountData.userLastName =
            restrictedClientData === null || restrictedClientData === void 0 ? void 0 : restrictedClientData.lastName;
        this.draftState.createAccountData.socialReason =
            restrictedClientData === null || restrictedClientData === void 0 ? void 0 : restrictedClientData.socialReason;
    };
    authState.prototype.checkNewIdentifiedUserFailure = function (errorMessage) {
        this.draftState.createAccountData.errorMessage = errorMessage;
        this.draftState.createAccountData.loading = false;
        this.draftState.createAccountData.createAccountSuccess = false;
    };
    authState.prototype.checkNewIdentifiedUserOld = function (payload) {
        this.draftState.loading = true;
        this.draftState.errorMessage = null;
        this.draftState.checkUserInfosSuccess = false;
        this.draftState.userFirstName = null;
    };
    authState.prototype.checkNewIdentifiedUserSuccessOld = function (data) {
        this.draftState.loading = false;
        this.draftState.checkUserInfosSuccess = true;
        this.draftState.errorMessage = null;
        this.draftState.userFirstName = data === null || data === void 0 ? void 0 : data.userFirstName;
    };
    authState.prototype.checkNewIdentifiedUserFailureOld = function (errorMessage) {
        this.draftState.errorNewCreatedUser = errorMessage;
        this.draftState.loading = false;
        this.draftState.checkUserInfosSuccess = false;
        this.draftState.userFirstName = null;
    };
    authState.prototype.createUserAccount = function (payload) {
        this.draftState.createAccountData.userEmail = payload.userEmail;
        this.draftState.createAccountData.acceptSaurContact =
            payload.acceptSaurContact;
        this.draftState.createAccountData.loading = true;
        this.draftState.createAccountData.errorMessage = null;
        this.draftState.createAccountData.emailSentToUser = false;
    };
    authState.prototype.createUserAccountSuccess = function () {
        this.draftState.createAccountData.loading = false;
        this.draftState.createAccountData.errorMessage = null;
        this.draftState.createAccountData.emailSentToUser = true;
    };
    authState.prototype.createUserAccountFailure = function (errorMessage) {
        this.draftState.createAccountData.loading = false;
        this.draftState.createAccountData.errorMessage = errorMessage;
        this.draftState.createAccountData.emailSentToUser = false;
    };
    authState.prototype.setCreateAccountInformation = function (payload) {
        this.draftState.createAccountData.userName = payload.userName;
        this.draftState.createAccountData.userReference = payload.userReference;
        this.draftState.createAccountData.userFirstName = payload.userFirstName;
    };
    authState.prototype.resetCreateAccountInformation = function () {
        this.draftState.createAccountData.userEmail = null;
        this.draftState.createAccountData.userName = null;
        this.draftState.createAccountData.acceptSaurContact = null;
        this.draftState.createAccountData.userReference = null;
        this.draftState.createAccountData.loading = false;
        this.draftState.createAccountData.emailSentToUser = false;
        this.draftState.createAccountData.errorMessage = null;
    };
    authState.prototype.finalizeCreateAccount = function (password) {
        this.draftState.finalizeCreateAccountLoading = true;
        this.draftState.createAccountData.setPasswordSuccess = false;
    };
    authState.prototype.finalizeCreateAccountSuccess = function () {
        this.draftState.finalizeCreateAccountLoading = false;
        this.draftState.finalizeCreateAccountErrorMessage = null;
        this.draftState.createAccountData.setPasswordSuccess = true;
    };
    authState.prototype.finalizeCreateAccountFailure = function (error) {
        this.draftState.finalizeCreateAccountLoading = false;
        this.draftState.finalizeCreateAccountErrorMessage = error;
        this.draftState.createAccountData.setPasswordSuccess = false;
    };
    authState.prototype.setCreateUserCaptchaToken = function (captchaToken) {
        this.draftState.createAccountData.createUserCaptchaToken = captchaToken;
    };
    authState.prototype.resendSubscriptionDemand = function () {
        this.draftState.createAccountData.resendSubscriptionMailLoading = true;
        this.draftState.createAccountData.resendSubscriptionMailSuccess = false;
        this.draftState.createAccountData.resendSubscriptionMailErrorMessage =
            null;
    };
    authState.prototype.resendSubscriptionDemandSuccess = function () {
        this.draftState.createAccountData.resendSubscriptionMailLoading = false;
        this.draftState.createAccountData.resendSubscriptionMailSuccess = true;
        this.draftState.createAccountData.resendSubscriptionMailErrorMessage =
            null;
    };
    authState.prototype.resendSubscriptionDemandFailure = function (errorMsg) {
        this.draftState.createAccountData.resendSubscriptionMailLoading = false;
        this.draftState.createAccountData.resendSubscriptionMailSuccess = false;
        this.draftState.createAccountData.resendSubscriptionMailErrorMessage =
            errorMsg;
    };
    /**
     *nouvelle methode pour mettre a jour le mail et la newsletter en même temps
     */
    authState.prototype.updateEmailAndNewsLetterFirstStep = function (payload) {
        this.draftState.updateEmailNewsLetter.loading = true;
    };
    authState.prototype.updateEmailAndNewsLetterFirstStepSuccess = function () {
        this.draftState.updateEmailNewsLetter.loading = false;
        this.draftState.updateEmailNewsLetter.errorMsg = null;
        this.draftState.updateEmailNewsLetter.firstStepResult = 'success';
    };
    authState.prototype.updateEmailAndNewsLetterFirstStepError = function (errorMessage) {
        this.draftState.updateEmailNewsLetter.loading = false;
        this.draftState.updateEmailNewsLetter.errorMsg = errorMessage;
        this.draftState.updateEmailNewsLetter.firstStepResult = 'failure';
    };
    /**
     * Premier appel à l'api pour demander la mise à jour de l'email.
     * Un mail sera envoyer à la nouvelle adresse du client
     */
    authState.prototype.updateEmailFirstStep = function (payload) {
        this.draftState.loading = true;
    };
    authState.prototype.updateEmailFirstStepSuccess = function () {
        this.draftState.loading = false;
        this.draftState.errorMessage = null;
        this.draftState.updateEmailData.firstStepResult = 'success';
    };
    authState.prototype.updateEmailFirstStepError = function (errorMessage) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMessage;
        this.draftState.updateEmailData.firstStepResult = 'failure';
    };
    authState.prototype.resetUpdateEmailFirstStepResult = function () {
        this.draftState.updateEmailData.firstStepResult = 'none';
    };
    authState.prototype.checkUpdateEmailTokenValidity = function (token) {
        this.draftState.loading = true;
    };
    authState.prototype.checkUpdateEmailTokenValiditySuccess = function () {
        this.draftState.loading = false;
        this.draftState.errorMessage = null;
        this.draftState.updateEmailData.isUpdateEmailRedirectionUrlExpired =
            false;
    };
    authState.prototype.checkUpdateEmailTokenValidityError = function (errorMsg, isExpired) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMsg;
        this.draftState.updateEmailData.isUpdateEmailRedirectionUrlExpired =
            isExpired;
    };
    authState.prototype.getUserLogin = function (clientId) {
        this.draftState.loading = true;
        this.draftState.errorMessage = null;
        this.draftState.data.login = null;
    };
    authState.prototype.getUserLoginFailure = function (errorMessage) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMessage;
        this.draftState.data.login = null;
    };
    authState.prototype.getUserLoginSuccess = function (payload) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.data.login = payload.login;
        this.draftState.errorMessage = null;
    };
    authState.prototype.unsubscribeUser = function () {
        this.draftState.loading = true;
        this.draftState.unsubscribe.errorMessage = null;
        this.draftState.unsubscribe.success = false;
    };
    authState.prototype.unsubscribeUserFailure = function (errorMessage) {
        this.draftState.loading = false;
        this.draftState.unsubscribe.errorMessage = errorMessage;
        this.draftState.unsubscribe.success = false;
    };
    authState.prototype.unsubscribeUserSuccess = function () {
        this.draftState.loading = false;
        this.draftState.unsubscribe.errorMessage = null;
        this.draftState.unsubscribe.success = true;
    };
    // Update client email with Billing number or Iban Number
    authState.prototype.updateUserEmail = function (payload) {
        this.draftState.updateEmailWithIbanOrBilling.loading = true;
        this.draftState.updateEmailWithIbanOrBilling.errorMsg = null;
    };
    authState.prototype.resetUpdateEmailWithIbanOrBilling = function () {
        this.draftState.updateEmailWithIbanOrBilling.loading = false;
        this.draftState.updateEmailWithIbanOrBilling.errorMsg = null;
    };
    authState.prototype.updateUserEmailSuccess = function () {
        this.draftState.updateEmailWithIbanOrBilling.loading = false;
    };
    authState.prototype.updateUserEmailFailure = function (errorMsg) {
        this.draftState.updateEmailWithIbanOrBilling.loading = false;
        this.draftState.updateEmailWithIbanOrBilling.errorMsg = errorMsg;
    };
    authState.prototype.checkUserEmail = function (payload) {
        this.draftState.updateEmailWithIbanOrBilling.loading = true;
        this.draftState.updateEmailWithIbanOrBilling.errorMsg = null;
    };
    authState.prototype.checkUserEmailSuccess = function () {
        this.draftState.updateEmailWithIbanOrBilling.loading = false;
    };
    authState.prototype.checkUserEmailFailure = function (errorMsg) {
        this.draftState.updateEmailWithIbanOrBilling.loading = false;
        this.draftState.updateEmailWithIbanOrBilling.errorMsg = errorMsg;
    };
    authState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    return authState;
}(immer_reducer_1.ImmerReducer));
exports.authState = authState;
exports.authActions = (0, immer_reducer_1.createActionCreators)(authState);
exports.authreducerFunction = (0, immer_reducer_1.createReducerFunction)(authState, exports.initialState);
